


















import { Component, Mixins, Prop } from 'vue-property-decorator'

import { getNewPropertyIcon, getPropertyTranslation } from '../../../../../../../../../../BotProperties/utils'
import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../Pi/types'
import { RemovePropertiesProxy } from '../../../../logic/Actions/RemoveProperties/RemovePropertiesProxy'
import { ActionNodeProps } from '../../../../logic/types'

@Component({})
export default class RemovePropertiesAction extends Mixins(UseFields) {
  @Prop() proxyAction!: RemovePropertiesProxy

  @Prop() getProperties!: ActionNodeProps['getProperties']

  get properties(): Array<SelectOptionData> {
    return this.getProperties()
      .filter(p => !p.readOnly && !p.automatic)
      .map((p) => {
        return {
          label: getPropertyTranslation(this.$i18n, p.name ?? p.type),
          value: p.id,
          icon: {
            name: getNewPropertyIcon(p.type),
            iconPack: 'material-icons',
          }
        }
      })
  }

  setIds(args: FieldData): FieldData {
    args.setter = value => this.proxyAction.setIdentifiers(value)

    return args
  }
}
